import React , {useState} from 'react'
// import { VStack, Input, Button,Text } from '@chakra-ui/react'
// import { FormControl, FormLabel } from '@chakra-ui/form-control'
// import { InputGroup, InputRightElement } from "@chakra-ui/input";
import { useToast } from "@chakra-ui/toast";
import axios from 'axios';
// import {useHistory} from 'react-router-dom'
import EnvRoute from '../middleware/envRoute';
import {AppState} from '../context/AppProvider';
const ENDPOINT = EnvRoute('prod'); 


const Signup  = (props) => {
  const [ firstName , setFirstName ] = useState()
  const [ lastName , setLastName ] = useState()
  const [ preferredName , setPreferredName ] = useState()
  const [ email , setEmail ] = useState()
  const [ phone, setPhone ] = useState()
  const [ password , setPassword ] = useState()
  const [ confirmPassword , setConfirmPassword ] = useState()
  const [ pic , setPic ] = useState()
  const [ isOnline , setIsOnline ] = useState(true)
  const [ actionError , setActionError ] = useState('')
  const [ OM_id, set_OM_id ] = useState()
  const [ TC_id, set_TC_id ] = useState()
  const [ picLoading , setPicLoading ] = useState(false)
  const [ show , setShow ] = useState(false)

  const linkage = true
  let view = props.view
  let setView = props.setView
  const {
        OM_user,
        setOM_user,
        TC_user,
        setTC_user,
        user,
        setUser } = AppState()
        
//   const history = useHistory()

  const handleClicK = () => {setShow(!show)}

  const toast = useToast();

  const OM_API = `https://open-mic-api.onrender.app/api`
  const TC_API = 'https://tin-can-api.onrender.app/api'
  
  const OM_API_LOC = `http://localhost:5001/api`
  const TC_API_LOC = 'http://localhost:5002/api'

  const OM_CHK =  `${OM_API}/user/status`//!---change to OM_API
  const TC_CHK =  `${TC_API}/user/status`

  const OM_REG =  `${OM_API}/user/reg`
  const TC_REG =  `${TC_API}/user`

  
  const linkageCheck = async (URI,ABRV) =>{
    /*------
    Make a call to openMic Api to see if this users email has an account
    if not:
    ----------- */
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post( URI, { email:email,linkage:true }, config);
      
      if (data)
      {
         if ( ABRV === 'OM' ){
           console.log('[OM_USER_INFO]:',data);
           set_OM_id(data?._id)
          }else if ( ABRV === 'TC' ){
            console.log('[TC_USER_INFO]:',data);
            set_TC_id(data?._id)
          }else{setActionError('Linkage Error: No API Reference')}
      }else{
        if ( ABRV === 'OM' ){OMLinkageSubmit(OM_REG)}
        else if ( ABRV === 'TC' ){TCLinkageSubmit(TC_REG)}
        else{setActionError('Linkage Error: No API Reference')}
      }
    } catch (error) {
      console.log((ABRV === 'OM')?'OpenMic':'TinCan',' registration failure:', error)
      setActionError(((ABRV === 'OM')?'OpenMic':'TinCan','Linkage Error Occured'))
    }
    
  }
  const OMLinkageSubmit = async (URI) =>{
    /*------
      Make a call to openMic Api to see if this users email has an account
      if not:
    */
  
   try {
     const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post(URI,
        { firstName,
          lastName,
          preferredName: preferredName? preferredName : firstName,
          email,
          phone,
          password,
          pic,
          isOnline,
          linkage
        },
        config
      );
      console.log('[OM_USER_INFO]:',data);
      set_OM_id(data?._id)
      setOM_user(data)
    } catch (error) {
      console.log('OpenMic registration failure:', error)
      setActionError('Error occured')

    }
    
  }
  const TCLinkageSubmit = async (URI) =>{
    /*------
      Make a call to openMic Api to see if this users email has an account
      if not:
    */
  
   try {
     const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post(URI,
        { 
          preferredName:preferredName? preferredName : firstName,
          email,
          phone,
          password,
          pic,
          isOnline,
          linkage
        },
        config
      );
      console.log('[TC_USER_INFO]:',data);
      set_TC_id(data?._id)
      setTC_user(data)
    } catch (error) {
      console.log('TinCan registration failure:', error)
      setActionError('Error occured')
    }
    
  }

//  =================
//  + SubmitHandler

//  =================
  const submitHandler = async () => {
    setPicLoading(true);
    if (!firstName || !lastName || !email || !password || !confirmPassword || !phone) {
      setActionError('Please Fill all the Feilds')
      setPicLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      // alert("Passwords Do Not Match")
        setActionError('Passwords Do Not Match')

      setPicLoading(false);
      return;
    }
    // console.log(firstName, lastName, preferredName, email, password, pic, phone);
    linkageCheck(OM_CHK, 'OM')
    linkageCheck(TC_CHK, 'TC')

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };
    try {
      setIsOnline(true)
      const { data } = await axios.post(
        `${ENDPOINT}/api/user/reg`,
        { firstName,
          lastName,
          preferredName:preferredName? preferredName : firstName,
          email,
          phone,
          password,
          pic,
          isOnline,
          OM_id: OM_id,
          TC_id: TC_id,
        },
        config
      );
      console.log(data);
      localStorage.setItem("TH_user", JSON.stringify(data));
      setPicLoading(false);
      setView('hub')
      window.location.href ='/hub'
    //   history.push("/chats");

    } catch (error) {
      setPicLoading(false);
      setActionError('Error occured')

    }
  };
//  =================
//  + Post Details

//  =================
  const postDetails = (pics) => {
    setPicLoading(true);
    if (pics === undefined) {
      return;
    } 
  
  if (pics.type === "image/jpeg" || pics.type === "image/png" || pics.type === "image/gif") {
      const data = new FormData();
      data.append("file", pics);
      data.append("upload_preset", "TinCan");
      data.append("cloud_name", "dzxzdsnha");
      fetch("https://api.cloudinary.com/v1_1/dzxzdsnha/upload", {
        method: "post",
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          setPic(data.url.toString());
          console.log(data.url.toString());
          setPicLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setPicLoading(false);
        });
    } else {
      setPicLoading(false);
      return;
    }
  }
  
  return (
    <>
    {/*   <div className='mx-auto bg-gray-200 '
        style={{borderRadius:'5px', 
        backgroundColor:'rgba(250,250,250,0.5)',
        backdropFilter: 'blur(13px)', width: '90%', 
        alignItems: 'center',
        boxShadow:'0px 0px 15px 1px rgba(250,250,250,0.5)',
        padding: '.5em',
        overflowX:'hidden',
        overflowY:'scroll',
        minHeight: '50%'

          }}> */}

    <div className='signup-wrap' style ={{color: '#fff',display: 'flex', flexDirection: 'column'}}>
        <h2>Sign Up</h2>
      <div id ="first-name" >
        <label>first name</label>
          <input  
            placeholder='enter your first name'
            type="text"
            onChange={(e)=>setFirstName(e.target.value)}
            required
            />
      </div>

      <div id ="last-name" >
        <label>last name</label>
          <input  
            placeholder='enter your  last name'
            type="text"
            onChange={(e)=>setLastName(e.target.value)}
            required
            />
      </div>

      <div id ="preferred-name" >
        <label>preferred name</label>
          <input  
            placeholder='enter your username'
            type="text"
            onChange={(e)=>setPreferredName(e.target.value)}
            required
            />
      </div>

      <div id ="email" style={{display:'flex', flexDirection: 'column', margin: 'auto'}} >
        <label>email</label>
          <input  
            placeholder='enter email'
            type="email"
            onChange={(e)=>setEmail(e.target.value.toLowerCase())}
            required
            />
      </div>

      <div id ="phone"  style={{display:'flex', flexDirection: 'column', margin: 'auto'}} >
        <label>phone</label>
          <input  
          type="phone"
            placeholder='enter phone number'
            onChange={(e)=>setPhone(e.target.value)}
            required
            />
      </div>

      <div id ="password" style={{display:'flex', flexDirection: 'column', margin: 'auto'}}  >
                <span style={{display: 'flex', margin: 'auto', width:'100%',}} >

          <button className='button-green'style={{color:'#fff',  margin:'0 .5rem'}} onClick={handleClicK}>
              {show ? "hide" : "show"}
            </button>
          <label>password</label>
        </span>
        
        <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <input  
            type={show ?'text':'password'}
              placeholder='enter password'
              onChange={(e)=>setPassword(e.target.value)}
              // border={'1px solid #868686'}
              // color={'#868686'}
              required
              />
        <div >
            
        </div>
        </span>
      </div>

      <div id ="confirm-password"  style={{display:'flex', flexDirection: 'column', margin: 'auto', }} >
    <span style={{display: 'flex', margin: 'auto', width:'100%',justifyContent:'center'}} >

          <button className='button-green'style={{ color:'#fff', margin:'0 .5rem'}} onClick={handleClicK}>
              {show ? "hide" : "show"}
            </button>
        <label>confirm password</label>
        </span>
        
        <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>

            <input  
            type={show ?'text':'password'}
            placeholder='re-enter password'
            onChange={(e)=>setConfirmPassword(e.target.value)}
            required
            />
        <div>
        </div>
        </span>
      </div>

      <div id ="pic" required>
        <label>upload pic</label>
        <input 
        type="file"
        p={1.5}
        accept ="image/*"
        onChange={(e) => postDetails(e.target.files[0])}
        border={'1px solid #868686'}
        color={'#868686'}
        width={'80%'}
        // m={'auto'}
        />
      </div>
      <h3 style={{color:"red"}}>{actionError?actionError:''}</h3>
       <button
      //  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      //   colorScheme="blue"
  className={actionError ? 'error-button' : 'signup-button'}
        style={{ marginTop: 15, width:"50%",margin: '0.5rem auto' }}
        onClick={submitHandler}
        // border={'1px solid #868686'}
        // isLoading={picLoading}
      >
        Sign Up
      </button>

    </div>
    
    </>
    //  </div>
  )
}

export default Signup